export const generateSelectMenuItems = (list, title, id) => {
  return list?.map((item) => {
    return { title: item?.[title], id: item?.[id] };
  });
};

export const getTablePaginationCount = (page, rowsPerPage, tableDataLength) => {
  const totalTableRows = page * rowsPerPage + tableDataLength;
  if (totalTableRows % rowsPerPage === 0) return totalTableRows + 1;
  else return totalTableRows;
};

export const reorderList = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

export const calculateDiscountedPrice = (price, discount) => {
  const discountValue = price * (discount / 100);
  const finalPrice = price - discountValue;
  return finalPrice;
};

// ------------------------------------------------------

const decodeHtml = (text) => {
  return text
    .replace(/&lt;/g, '<<')
    .replace(/&gt;/g, '>>')
    .replace(/&nbsp;/g, ' ')
    .trim();
};

export const cleanText = (text) => {
  const decodedText = decodeHtml(text);
  return decodedText.replace(/[^a-zA-Z0-9\u0600-\u06FF\s.,?!،؛<>]/g, ''); // نگه‌داشتن حروف فارسی و انگلیسی و علائم مجاز
  // return decodedText;
};
